// Gatsby requirements
import React from 'react'

// Components
import RichText from "utils/RichTextRenderer"

// Styles
import * as CSS from './SectionTable.module.scss'


const SectionCard = ({ content }) => {

    return (
        <div className={`
            ${CSS.card}
            ${'section' + content._uid}
        `}>

            {content?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    content.css.replaceAll('.section', '.section' + content._uid)
                }} />
            }  

            <div>

                {content?.topText &&
                    <div className={CSS.topText}>
                        <RichText content={content.topText} />
                    </div>
                }

                <div className={CSS.tableWrapper}>
                    <table>
                        {content?.table?.tableData.map((loop, i) => (
                            <tr>
                                {i === 0 ? 
                                    <>
                                        {loop.map((loop2) => (
                                            <th>{loop2}</th>
                                        ))}
                                    </>
                                    :
                                    <>
                                        {loop.map((loop3) => (
                                            <td>
                                                {loop3}
                                            </td>
                                        ))}
                                    </>
                                }
                            </tr>
                        ))}
                    </table>
                </div>

                {content?.bottomText &&
                    <div className={CSS.bottomText}>
                        <RichText content={content.bottomText} />
                    </div>
                }

            </div>            
        </div>
    )
}

export default SectionCard